import React from 'react';

type UpfrontPricingType = {
	HasData: boolean;
	HasMemberData: boolean;
	MemberUpfrontPaymentAmount?: number | null;
	UpfrontPaymentAmount?: number | null;
	UpfrontPaymentPercentage?: number | null;
};

type FinanceInstallmentProps = {
	UpfrontPricing: UpfrontPricingType;
	UseUpfrontPricingAmounts: boolean;
	DeliveryPricingInPricePod: boolean;
	NewDayFinanceQuote: any;
	isSwitch24Product: boolean;
	switchMonthlyPayment: number;
};

export function FinanceInstallments({
	UpfrontPricing = {
		HasData: false,
		HasMemberData: false,
	},
	UseUpfrontPricingAmounts,
	DeliveryPricingInPricePod,
	NewDayFinanceQuote,
	isSwitch24Product,
	switchMonthlyPayment,
}: FinanceInstallmentProps) {
	const financeTextFactory = () => {
		let correctUpfrontValue = UpfrontPricing?.UpfrontPaymentAmount;

		const financeTextWithSwitch = () => {
			const formattedSwitch24MonthlyPayment = `£${switchMonthlyPayment?.toFixed(
				2
			)}`;
			return isSwitch24Product
				? `from ${formattedSwitch24MonthlyPayment} monthly* `
				: `from ${NewDayFinanceQuote.FormattedMonthlyPriceString} monthly* `;
		};

		const upfrontCriteriaMet =
			UseUpfrontPricingAmounts && UpfrontPricing.HasData;

		if (isSwitch24Product) {
			correctUpfrontValue = UpfrontPricing?.MemberUpfrontPaymentAmount
				? UpfrontPricing?.MemberUpfrontPaymentAmount
				: UpfrontPricing?.UpfrontPaymentAmount;
		}

		const financeTextWithSwitchResult = financeTextWithSwitch();

		let financeText = DeliveryPricingInPricePod
			? `${financeTextWithSwitchResult}`
			: `or from ${NewDayFinanceQuote.FormattedMonthlyPriceString} monthly* `;

		if (upfrontCriteriaMet) {
			const formattedUpfrontPaymentAmount = correctUpfrontValue?.toFixed(2);

			const sliceIndex = isSwitch24Product ? -1 : -2;
			financeText =
				financeText.slice(0, sliceIndex) +
				(isSwitch24Product
					? ` \n plus £${formattedUpfrontPaymentAmount} upfront`
					: ` plus \n £${formattedUpfrontPaymentAmount} upfront today*`);
		}

		return { financeText, upfrontCriteriaMet };
	};

	const { financeText, upfrontCriteriaMet } = financeTextFactory();

	return (
		<div
			className={upfrontCriteriaMet ? 'whitespace-pre-line leading-normal' : ''}
			data-testid="finance-text-with-optional-upfront">
			{financeText}
			<span
				className={isSwitch24Product ? '' : 'ico ico-chevron-right ico-lg'}
				data-testid="optional-chevron-element"
			/>
		</div>
	);
}
